import Vuex from 'vuex';
import * as _ from 'lodash';

import { ConstantsTypesMap } from '@/constants';
import { LocalStorageService } from './services';
import { LocalStorageKeys } from './services/localStorage.service';

export const ACTIONS = {
  SET_CONSTANTS: 'setConstants',
  OVERRIDE_FEATURE_TOGGLE: 'overrideFeatureToggle'
};

const StatesMap = {
  CONSTANTS: 'constants'
};

export default () =>
  new Vuex.Store({
    state: {
      [StatesMap.CONSTANTS]: null
    },
    mutations: {
      setConstants(state, constants) {
        state[StatesMap.CONSTANTS] = constants;
      },
      setFeatureToggleEnabled(state, { name, enabled }) {
        const featureToggles =
          state[StatesMap.CONSTANTS][ConstantsTypesMap.FEATURE_TOGGLE];
        const targetFeatureToggle = featureToggles.find(
          ({ name: toggleName }) => toggleName === name
        );

        if (!targetFeatureToggle) {
          throw new Error(`Feature toggle ${name} does not exist.`);
        }

        targetFeatureToggle.enabled = enabled;
      }
    },
    getters: {
      getConstantsByType: (state) => (type) => {
        const constants = _.clone(state[StatesMap.CONSTANTS]);

        return _.get(constants, type);
      },
      getFeatureToggleByName: (state, getters) => (name) => {
        const featureToggles = getters.getConstantsByType(
          ConstantsTypesMap.FEATURE_TOGGLE
        );

        return _.find(featureToggles, { name: name });
      },
      getFeatureToggleByNameEnabled: (state, getters) => (name) => {
        const featureToggle = getters.getFeatureToggleByName(name);

        return _.get(featureToggle, 'enabled');
      },
      isMatcherApiV2Enabled: (state, getters) => {
        return getters.getFeatureToggleByNameEnabled('matcher_api_v2');
      }
    },
    actions: {
      setConstants({ commit }, constants) {
        const clonedCloneConstants = _.clone(constants);
        const featureToggleOverrides =
          LocalStorageService.getJSON(
            LocalStorageKeys.FEATURE_TOGGLE_OVERRIDES
          ) || {};

        // Hydrate the server feature toggle values with the local storage
        clonedCloneConstants.featureToggle =
          clonedCloneConstants.featureToggle.map((featureToggle) => ({
            ...featureToggle,
            enabled:
              featureToggle.id in featureToggleOverrides
                ? featureToggleOverrides[featureToggle.id]
                : featureToggle.enabled,
            // Used for displaying toggle status in the UI
            isLocalOverride: featureToggle.id in featureToggleOverrides
          }));

        commit('setConstants', clonedCloneConstants);
      },
      overrideFeatureToggle({ dispatch, state }, { toggleId, enabled }) {
        LocalStorageService.set(LocalStorageKeys.FEATURE_TOGGLE_OVERRIDES, {
          ...(LocalStorageService.getJSON(
            LocalStorageKeys.FEATURE_TOGGLE_OVERRIDES
          ) || {}),
          [toggleId]: enabled
        });

        // Reload constants to pull from updated local values
        dispatch(ACTIONS.SET_CONSTANTS, state.constants);
      }
    }
  });
